import configHandler from '../../configHandler'
import svHandler from './NationalNumberSv'
import noHandler from './NationalNumberNo'

export const ERROR_TOO_SHORT = 'tooShort'
export const ERROR_TOO_LONG = 'tooLong'
export const ERROR_INVALID_NUMBER = 'invalidNumber'
export const ERROR_INVALID_BIRTHDATE = 'invalidBirthdate'

export const error = (key) => {
    return configHandler.errorMessages().nationalNumber[key]
}

export const parse = (inputNumber) => {
    let number = String(inputNumber)
        .replace(/ /g, '')
        .replace(/-/g, '')
        .replace(/\./g, '')

    let handler
    switch (configHandler.regionKey) {
        case 'sv':
            handler = svHandler(number)
            break
        case 'no':
        default:
            handler = noHandler(number)
    }

    return {
        inputNumber: inputNumber,
        handler: handler,

        format: function () {
            return this.handler.format()
        },
        formatMasked: function () {
            return this.handler.formatMasked()
        },
        formatUnmasked: function () {
            return this.handler.formatUnmasked()
        },
        validate: function () {
            return this.handler.validate()
        },
        validateBirthdate: function () {
            return this.handler.validateBirthdate()
        },
        validateNationalNumber: function () {
            return this.handler.validateNationalNumber()
        },
        isValid: function () {
            return this.handler.isValid()
        },
        isValidBirthdate() {
            return this.handler.isValidBirthdate()
        },
        isValidNationalNumber() {
            return this.handler.isValidNationalNumber()
        },
        isNationalNumber: function () {
            return this.handler.isNationalNumber()
        },
        input: function () {
            return inputNumber
        },
        isMale: function () {
            return this.handler.isMale()
        },
        isFemale: function () {
            return this.handler.isFemale()
        },
        birthdate: function () {
            return this.handler.birthdate()
        },
    }
}

export default {
    parse,
}